export default "https://cdn-static-unstable.gokick.com/assets/6c6ec7987c723fb20ca76f9d1acc92ca38fc33c2/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";